export async function sendQuizFormRequest(email) {
  const response = await fetch('/api/auth/send-restore-password-link', {
    method: 'post',
    body: JSON.stringify({ email: email }),
    headers: {
      'content-type': 'application/json',
    },
    redirect: 'follow',
    cache: 'no-cache',
  });

  const { success, errors } = await response.json();

  if (!success) {
    const [{ name, message }] = errors;
    const error = new Error(message);
    error.name = name;
    throw error;
  }
}
